import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ExtraArg, RootState } from './root-state';

export interface RejectError {
  message: string;
  status?: number;
  code?: string;
  details?: unknown;
  needsOnboarding?: boolean;
}

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  extra: ExtraArg;
  rejectValue: RejectError;
}>();
